import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=623fcdc0&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=623fcdc0&scoped=true&lanf=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623fcdc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623fcdc0')) {
      api.createRecord('623fcdc0', component.options)
    } else {
      api.reload('623fcdc0', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=623fcdc0&scoped=true&", function () {
      api.rerender('623fcdc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/NotFound.vue"
export default component.exports